<template>
	<Button @click="onClick" type="primary" :size="size" :disabled="disabled">
		<template #icon>
			<IconPlus :size="size" style="margin-right: 4px" />
		</template>
		<slot />
	</Button>
</template>

<script>
import Button from './Button.vue'
import IconPlus from '../icon/IconPlus.vue'
import ButtonMixin from './ButtonMixin.js'
export default {
	mixins: [ButtonMixin],
	components: {
		Button,
		IconPlus
	}
}
</script>
